import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faHome,faStar, faListAlt,faExclamationTriangle,faSignOutAlt,faHistory,faClipboardCheck, faTasks, faBriefcase, faTimes, faChartPie, faUsers, faBed, faCog, faUserMd, faBook, faDoorOpe } from "@fortawesome/free-solid-svg-icons";
import {  NavBtnLink, NavBtnAvatar, NavNotification } from "../components/navbar/NavbarElements.js"
import { Nav, Badge, Image, Button, Dropdown, Accordion} from '@themesberg/react-bootstrap';
import NavbarComponent from "../components/navbar/index";
import { Sidebar } from "../components/sidebar";
import { Link } from 'react-router-dom';
import { Routes } from "../routes";
import { useAuth } from "../Context/AuthContext";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import { toast } from 'react-toastify';
import {  faEnvelopeOpen, faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import {MobileIcon} from "../components/navbar/NavbarElements.js";
import { FaBars } from "react-icons/fa";
import NotificationDropdown from "./Notifications.js";
import MessagesNotifications from "./Messages.js";
import Location from './../components/Location';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from "../constants.js";
export default ({notifications}) => {

  const [show, setShow] = useState(false);
    const { user, setUser, logout } = useAuth();
  const [scrollNav, setScrollNav] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation(); 
  const navigate = useNavigate();
    const { pathname } = location;

  const isHomePage = location.pathname === '/';
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const changeNav = () => {
      if (window.scrollY >= 80) {
        setScrollNav(true);
      } else {
        setScrollNav(false);
      }
    };

    window.addEventListener("scroll", changeNav);

    // Check for token presence and user data on page load
    const token = localStorage.getItem('token');
    const savedUserData = localStorage.getItem('userData');

    // If token and user data are present, keep user logged in
    if (token && savedUserData) {
      setIsLoggedIn(true);
      setUser(JSON.parse(savedUserData));
    } else {
      // If token or user data is missing, make sure to log out
      setIsLoggedIn(false);
      setUser(null);
    }
    setLoading(false);
    return () => window.removeEventListener("scroll", changeNav);

  }, [setUser]);

  const handleLogout = async () => {
    const userId = user?.id; 

    try {
      // Make the API request to logout the user
      await axios.post(`${BASE_URL}/users/logout`, { userId }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`, // Include token if needed
        },
      });

      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      setIsLoggedIn(false);
      setUser(null); // Clear the user data in state
      logout(); 
      navigate('/'); 
      // Show a success message
      toast.success('Logout successful');
    } catch (error) {
      console.error('Error logging out:', error);
      toast.error('Logout failed. Please try again.');
    }
  };
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show); 

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
   <Sidebar isOpen={isOpen} toggle={toggle} isHomePage={isHomePage}/>
   <NavbarComponent toggle={toggle} isHomePage={isHomePage}/>
    {!isHomePage && !user?.isRefugee && (
  <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
    <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
      <div className="sidebar-inner px-4 pt-3">
        <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
          <div className="d-flex align-items-center">
            <div className="user-avatar lg-avatar me-4">
              <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
            </div>
            <div className="d-block">
              <h6>Hi, </h6>
              <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} onClick={handleLogout} className="text-dark">
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
              </Button>
            </div>
          </div>
          <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
            <FontAwesomeIcon icon={faTimes} />
          </Nav.Link>
        </div>

        {/* Admin-specific navigation */}
        {user?.isAdmin && (
      
          <Nav className="flex-column pt-3 pt-md-0">
            <NavItem title="Ordamo" link={Routes.Presentation.path} />
            <NavItem title="Overview" link={Routes.DashboardOverview.path} icon={faChartPie} />
            <NavItem title="Rooms" icon={faBed} link={Routes.Rooms.path} />
            <NavItem title="Users" icon={faUsers} link={Routes.Transactions.path} />
            <NavItem title="Manage Task" icon={faTasks} link={Routes.AssignTasks.path} />
            <NavItem title="Availability" icon={faHistory} link={Routes.Availability.path} />
            <NavItem title="Courses" icon={faBook} link={Routes.Courses.path} />
            <NavItem title="Jobs" icon={faBriefcase} link={Routes.Jobs.path} />
           
          
          </Nav>
        )}
    
        {/* State-specific navigation */}
        {user?.isState && (
          <Nav className="flex-column pt-3 pt-md-0">
            <NavItem title="Ordamo" link={Routes.Presentation.path}  />
            <NavItem title="Overview" link={Routes.StateOverview.path} icon={faChartPie} />
            <NavItem title="Shelters" icon={faHome} link={Routes.Shelters.path} />    
          {/* <NavItem title="Shelter Loss" icon={faExclamationTriangle} link={Routes.ShelterLoss.path} />*/}
            <NavItem title="All Shelters Losses" icon={faListAlt} link={Routes.AllShelterLosses.path} />
            <NavItem title="Recommandation" icon={faStar} link={Routes.BestShelters.path} />
            <NavItem title="Admins" icon={faUsers} link={Routes.AllAdmins.path} />
          </Nav>
        )}
      </div>
    </SimpleBar>
  </CSSTransition>
)}


    </>
  );
};